import { Button } from "components/DesignSystem/Button/Button";
import { FiCheck } from "components/icons/FiCheck";
import { FiCross } from "components/icons/FiCross";
import { NONE_OF_THESE, REVIEW_ACTION } from "v2/constants/extractionReview";
import type {
  ReviewActionFn,
  ReviewFieldAction,
} from "v2/types/extractionReview.types";

type ConfirmRejectButtonsProps = {
  id: string;
  onAction: ReviewActionFn;
  rejectAsChoose?: boolean;
  confirmDisabled?: boolean;
  // For a conflict: confirm carries the picked candidate so the server confirms + chooses
  // atomically, closing the "choose PATCH hasn't landed yet" race.
  confirmCandidateUuid?: string;
  pendingAction?: ReviewFieldAction | null;
};

export const ConfirmRejectButtons = ({
  id,
  onAction,
  rejectAsChoose = false,
  confirmDisabled = false,
  confirmCandidateUuid,
  pendingAction = null,
}: ConfirmRejectButtonsProps) => {
  const handleConfirm = () =>
    confirmCandidateUuid
      ? onAction(id, REVIEW_ACTION.CONFIRM, confirmCandidateUuid)
      : onAction(id, REVIEW_ACTION.CONFIRM);
  // In a conflict the "reject" button means "none of these" → a choose with the
  // sentinel uuid; otherwise a plain reject.
  const handleReject = () => {
    if (rejectAsChoose) {
      onAction(id, REVIEW_ACTION.CHOOSE, NONE_OF_THESE);
    } else {
      onAction(id, REVIEW_ACTION.REJECT);
    }
  };

  return (
    <div className="t-flex t-shrink-0 t-items-center t-gap-2">
      <Button
        customType="secondary"
        size="xsmall"
        leftIcon={
          <span className="t-flex t-shrink-0 t-text-dark_green">
            <FiCheck />
          </span>
        }
        isLoading={pendingAction === REVIEW_ACTION.CONFIRM}
        onClick={handleConfirm}
        disabled={confirmDisabled}
      >
        Confirm
      </Button>
      <Button
        customType="secondary"
        size="xsmall"
        leftIcon={
          <span className="t-flex t-shrink-0 t-text-red">
            <FiCross />
          </span>
        }
        isLoading={
          pendingAction === REVIEW_ACTION.REJECT ||
          pendingAction === REVIEW_ACTION.CHOOSE
        }
        onClick={handleReject}
      >
        {rejectAsChoose ? "None of these" : "Reject"}
      </Button>
    </div>
  );
};
